import { useEffect } from 'react';
import styles from './useInteractionLock.module.scss';

let currentDepth = 0;

export const useInteractionLock = (lock: boolean = false) => {

    useEffect(() => {

        if (lock) {
            currentDepth++;
        }

        toggleInteraction(currentDepth > 0);

        return () => {

            if (lock) {
                currentDepth--;
            }

            if (currentDepth === 0) {
                toggleInteraction(false);
            }
        };
    }, [lock]);
};

const toggleInteraction = (force: boolean) => {
    document.documentElement.classList.toggle(styles.disableInteraction, force);
    document.body.classList.toggle(styles.disableInteraction, force);
};